
export default function Settings() {
  return (
    <div className="title-container">
      <h2>Settings</h2>
    </div>
  );
}
